<template>
  <!-- Main Navigation -->
  <div id="main-navigation" class="container-1200 d-none d-md-flex justify-content-between">
    <div class="nav-wrapper flex-grow-1 mr-2 position-relative">
      <div v-if="isDisabled" class="disabled-overlay" />
      <!-- Concept -->
      <step
        :step-data="steps['concept']"
        :active-step="activeStep"
        @toggle-step="onToggleStep"
        @away-settings="onAwaySettings"
      />
      <!-- /Concept -->

      <!-- Research -->
      <step
        :step-data="steps['research']"
        :active-step="activeStep"
        @toggle-step="onToggleStep"
        @away-settings="onAwaySettings"
      />
      <!-- /Research -->

      <!-- Set Up -->
      <step
        :step-data="steps['setup']"
        :active-step="activeStep"
        @toggle-step="onToggleStep"
        @away-settings="onAwaySettings"
      />
      <!-- /Set Up -->

      <!-- Projections -->
      <step
        :step-data="steps['projections']"
        :active-step="activeStep"
        @toggle-step="onToggleStep"
        @away-settings="onAwaySettings"
      />
      <!-- /Projections -->

      <!-- Validation -->
      <!--      <step-->
      <!--        :step-data="steps['validation']"-->
      <!--        :active-step="activeStep"-->
      <!--        :show-counter="false"-->
      <!--        @toggle-step="onToggleStep"-->
      <!--        @away-settings="onAwaySettings"-->
      <!--      />-->
      <!-- /Validation -->
    </div>

    <div class="position-relative">
      <div v-if="isDisabled" class="disabled-overlay-prev-next-buttons" />
      <PreviousNextButtons
        class="d-none d-lg-flex"
        :disabled="isDisabled"
        @navigate-back="navigateBack"
        @navigate-next="navigateNext"
      />
    </div>
  </div>
  <!-- /Main Navigation -->

</template>

<script>
import MixinStoryModeSteps from '@/mixins/storyModeSteps'
import PreviousNextButtons from '@/views/Home/StoryMode/Components/MainNavigation/PreviousNextButtons.vue'
import Step from './Step/Step'
import { mapGetters } from 'vuex'

export default {
  name: 'MainNavigation',

  components: {
    PreviousNextButtons,
    Step
  },

  mixins: [
    MixinStoryModeSteps
  ],

  provide () {
    return {
      getBack: () => this.back,
      getNext: () => this.next
    }
  },

  props: {
    back: {
      type: Object,
      default: () => ({
        disabled: false,
        title: '',
        route: ''
      })
    },

    next: {
      type: Object,
      default: () => ({
        disabled: false,
        title: '',
        route: ''
      })
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      activeStep: '',
      timeout: null
    }
  },

  computed: {
    ...mapGetters('ui', ['getLoaders']),

    isDisabled () {
      return this.getLoaders.aiBuddy || this.getLoaders.aiTemplate
    }
  },

  methods: {
    onToggleStep (stepToActivate) {
      clearTimeout(this.timeout)

      if (stepToActivate) {
        this.activeStep = stepToActivate
      } else {
        this.closeStep()
      }
    },

    closeStep () {
      this.timeout = setTimeout(() => {
        this.activeStep = null
      }, 100)
    },

    onAwaySettings () {
      this.activeStep = ''
    },

    navigateBack () {
      this.$router.push({ name: this.back.route })

      this.$gtm.trackEvent({
        event: 'backButton'
      })
    },

    navigateNext () {
      this.$router.push({ name: this.next.route })

      this.$gtm.trackEvent({
        event: 'nextButton'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.disabled-overlay {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: $color-white;
  opacity: 0.5;
  cursor: not-allowed;
}

.disabled-overlay-prev-next-buttons {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  cursor: not-allowed;
}
</style>
